import React from 'react';

import { clearRedirect, loadOrgNotifications, newNotification, saveNotification, getNotification, logout} from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Button from  '@material-ui/core/Button'
import { Redirect } from  "react-router-dom";
import Header from './../Header';
import Footer from './../Footer';
import NotificationList from './../lists/NotificationList';
import Toolbar from '@material-ui/core/Toolbar';
import Snackbar from '@material-ui/core/Snackbar';
import OldBrowserMessage from './../OldBrowserMessage';

export class OrgCabinet extends React.Component {
    
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            redirect: null,
            user: {},
            auth: false,
            notifications: [],
            notification: {}
        }
    }

    createNotification = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        this.props.newNotification(user.token);
    }
    
    componentWillMount() {
        this.props.clearRedirect();
        let open =  ('state' in this.props.location) && typeof this.props.location.state !== 'undefined' ? ('message' in this.props.location.state) ? true : false : false;
        let user = JSON.parse(localStorage.getItem('user'));
        if( user !== null ){
            if (user.role.indexOf('ROLE_BUILD_ORG')>=0 || user.role.indexOf('ROLE_BUILD_USER')>=0) {
                this.setState({auth: true, user: user, open: open});
                this.props.loadNotifications(user.token);
            }
        }

    }

    logout = () => {
        this.props.logout() ;
        this.setState({auth:false, redirect: null, user:{}});
    }

    handleClose = (event, reason) => {
        this.setState({ open: false });
    };

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        if (this.props.redirect !== null) {
            console.log(this.props.redirect);
            return (<Redirect to={{
                pathname: `/${this.props.redirect}`,
                state: { referrer: this.props.notification }
            }} />)
        } else {

        let notifications = this.props.notifications;
        let list = notifications.length > 0 ?
            <NotificationList type='org' items={notifications} openLink="notification" title="Уведомления"/>:
            <p> В архиве уведомлений нет</p>
            return (
                <div>
                    <Header link={{ title: this.state.user.org, to: '/org-cabinet/' }} />
                    <Toolbar>
                        <Button style={{ display: 'inline-block', border: '1px solid transparent' }} onClick={this.createNotification}>Создать уведомление</Button>
                        {(this.state.user.role.indexOf('ROLE_BUILD_ORG') > -1 || this.state.user.role.indexOf('ROLE_BUILD_USER') > -1) && (<Button style={{ display: 'inline-block', border: '1px solid transparent' }} component={Link} to="/org-profile/">Профиль организации</Button>)}
                        {(this.state.user.role.indexOf('ROLE_BUILD_ORG') > -1) && (<Button style={{ display: 'inline-block', border: '1px solid transparent' }} component={Link} to="/org-users/">Управление пользователями</Button>)}
                        <Button style={{ display: 'inline-block', border: '1px solid transparent' }} component={Link} to="/manage-account/">Личный профиль</Button>
                        <Button style={{ display: 'inline-block', border: '1px solid transparent' }} onClick={this.logout}>Выйти</Button>
                    </Toolbar>
                    <OldBrowserMessage />
                    {list}
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        open={this.state.open}
                        autoHideDuration={2000}
                        onClose={this.handleClose}
                        variant="success"
                        message={<span id="message-id">{this.state.open ? this.props.message : ''}</span>}
                    />
                    <Footer />
                </div>);
        }
    }
}


    /* loadInspections, newNotification, signNotification, saveNotification, getNotification*/
function select(state, props) {
        const { notifications } = state;
        console.log('SELECT');
        console.log(notifications);
        return {
            notifications: (typeof notifications !== "undefined" && 'data' in notifications) ? notifications.data : [],
            notification: (typeof notifications !== "undefined" && 'item' in notifications) ?  notifications.item : {},
            redirect: (typeof notifications !== "undefined" && 'redirect' in notifications) ?  notifications.redirect : null,
            message: (typeof notifications  !== "undefined" && 'message' in notifications) ?  notifications.message : ''
        };
    }

OrgCabinet.defaultProps = {
    notifications: [],
    redirect: null
}


function mapDispatch(dispatch) {
    return {
        loadNotifications: bindActionCreators(loadOrgNotifications, dispatch),
        getNotification: bindActionCreators(getNotification, dispatch),
        newNotification: bindActionCreators(newNotification, dispatch),
        saveNotification: bindActionCreators(saveNotification, dispatch),
        logout: bindActionCreators(logout, dispatch),
        clearRedirect: bindActionCreators(clearRedirect, dispatch),
    };
}


export default connect(select, mapDispatch)(OrgCabinet);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/OrgCabinet.jsx